(function () {
  const Core = window.RB.Core;
  const { buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Ravenbloom Student": {
      triggers: [{
        on: "finalizedCard",
        condSpec: { k: "and", conds: [{ k: "evYou" }, { k: "evType", type: "spell" }] },
        label: "+1 Might this turn",
        program: [buff("source", 1)],
      }],
    },

    "Eager Apprentice": {
      spellCostMod: { less: 1, min: 1, whileAtBf: true },
    },

    "Stupefy": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit -1 Might this turn?" }],
      play: [
        { op: "if", cond: { k: "targetMightAtLeast", bind: "t", n: 2 }, then: [buff("$t", -1)] },
        { op: "draw", n: 1 },
      ],
    },

    "Blastcone Fae": {
      play: [
        { op: "choose", bind: "t", spec: { type: "unit" }, prompt: "Give a unit -2 might this turn (min 1)" },
        { op: "grant", to: "$t", might: -2, floor: 1 },
      ],
    },

    "Sprite Mother": {
      play: [{ op: "token", name: "Sprite", loc: "here", ready: true }],
    },

    "Thousand-Tailed Watcher": {
      play: [{ op: "grant", spec: { type: "unit", enemy: true }, might: -3, floor: 1 }],
    },

    "Ahri, Inquisitive": {
      triggers: [
        {
          on: "attack", self: true, label: "essence drain",
          program: [
            { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Give which enemy unit here -2 might (min 1)?" },
            { op: "grant", to: "$t", might: -2, floor: 1 },
          ],
        },
        {
          on: "defend", self: true, label: "essence drain",
          program: [
            { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Give which enemy unit here -2 might (min 1)?" },
            { op: "grant", to: "$t", might: -2, floor: 1 },
          ],
        },
      ],
    },

    "Teemo, Strategist": {
      triggers: [
        {
          on: "defend", self: true, label: "scout's ambush", onceKey: "ambush",
          program: [
            { op: "revealTopCount", n: 5, matchKw: "hidden", varKey: "hid" },
            { op: "if", cond: { k: "varAtLeast", key: "hid", n: 1 }, skip: 2 },
            { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Deal 1 per revealed Hidden card to which enemy unit here?" },
            { op: "deal", to: "$t", n: { varOf: "hid" } },
          ],
        },
        {
          on: "played", self: true, label: "scout's ambush", onceKey: "ambush",
          condSpec: { k: "evFromFacedown" },
          program: [
            { op: "revealTopCount", n: 5, matchKw: "hidden", varKey: "hid" },
            { op: "if", cond: { k: "varAtLeast", key: "hid", n: 1 }, skip: 2 },
            { op: "choose", bind: "t", spec: { type: "unit", enemy: true, here: true }, prompt: "Deal 1 per revealed Hidden card to which enemy unit here?" },
            { op: "deal", to: "$t", n: { varOf: "hid" } },
          ],
        },
      ],
    },

    "Pit Crew": {
      triggers: [{
        on: "played", you: true, label: "pit stop",
        condSpec: { k: "and", conds: [{ k: "evOther" }, { k: "evType", type: "gear" }] },
        program: [{ op: "ready", to: "source" }],
      }],
    },

    "Viktor, Innovator": {
      triggers: [{
        on: "finalizedCard", you: true, label: "glorious evolution",
        condSpec: { k: "and", conds: [{ k: "evOther" }, { k: "notMyTurn" }] },
        program: [{ op: "token", name: "Recruit", n: 1 }],
      }],
    },

    "Wraith of Echoes": {
      triggers: [{
        on: "dies", friendlyUnit: true, oncePerTurn: true, label: "echoes",
        condSpec: { k: "evSnapshotUnit" },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Gemcraft Seer": {
      auraKwSpecs: [{ name: "vision", value: null, excludeSelf: true }],
    },

    "Dr. Mundo, Expert": {
      selfMight: function (state, iid) {
        return state.players[state.objs[iid].controller].trash.length;
      },
      triggers: [{
        on: "beginningPhase", you: true, label: "purge",
        program: [
          { op: "choose", bind: "t", spec: { zone: "trash" }, min: 3, max: 3, prompt: "Recycle 3 from your trash" },
          { op: "recycleTargets", to: "$t" },
        ],
      }],
    },

    "Smoke Screen": {
      targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Give which unit -4 might (min 1)?" }],
      play: [{ op: "grant", to: "$t", might: -4, floor: 1 }],
    },

    "Sprite Call": {
      play: [{ op: "token", name: "Sprite", loc: "here", ready: true }],
    },

    "Retreat": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Return which friendly unit to hand?" }],
      play: [
        { op: "toHand", to: "$t" },
        { op: "channel", n: 1, exhausted: true },
      ],
    },

    "Singularity": {
      targets: [{ bind: "t", spec: { type: "unit" }, min: 0, max: 2, prompt: "Deal 6 to each of up to two units" }],
      play: [{ op: "deal", to: "$t", n: 6 }],
    },

    "Unchecked Power": {
      play: [
        { op: "exhaust", spec: { type: "unit", friendly: true } },
        { op: "deal", spec: { type: "unit", atBf: true }, n: 12 },
      ],
    },

    "Convergent Mutation": {
      targets: [
        { bind: "a", spec: { type: "unit", friendly: true }, prompt: "Whose Might changes?" },
        { bind: "b", spec: { type: "unit", friendly: true, notBind: "a" }, prompt: "Copy which friendly unit's Might?" },
      ],
      play: [{ op: "grant", to: "$a", setMight: { mightOf: "$b" }, dur: "turn" }],
    },

    "Guerilla Warfare": {
      play: [
        { op: "choose", bind: "t", spec: { zone: "trash", hasKw: "hidden" }, min: 0, max: 2, prompt: "Return up to two Hidden cards to your hand" },
        { op: "toHand", to: "$t" },
        { op: "freeHides" },
      ],
    },

    "Siphon Power": {
      targets: [{ bind: "b", spec: { zone: "battlefield" }, prompt: "Choose a battlefield" }],
      play: [
        { op: "grant", spec: { type: "unit", friendly: true }, at: "$b", might: 1 },
        { op: "grant", spec: { type: "unit", enemy: true }, at: "$b", might: -1, floor: 1 },
      ],
    },

    "Orb of Regret": {
      abilities: [{
        label: "Exhaust: give a unit -1 might this turn (min 1)", exhausts: true,
        program: [
          { op: "choose", bind: "t", spec: { type: "unit" }, prompt: "Give which unit -1 might?" },
          { op: "grant", to: "$t", might: -1, floor: 1 },
        ],
      }],
    },

    "Malzahar, Fanatic": {
      abilities: [{
        label: "Kill a friendly unit or gear, exhaust: Add 2 rainbow power", exhausts: true, action: true,
        program: [
          { op: "choose", bind: "k", spec: { orSpecs: [{ type: "unit", friendly: true }, { type: "gear", friendly: true }] }, prompt: "Kill which friendly unit or gear?" },
          { op: "kill", to: "$k" },
          { op: "addResources", res: { anyPower: 2 } },
        ],
      }],
    },

    "Herald of the Arcane": {
      abilities: [{
        label: "1 energy, exhaust: play a Recruit token", exhausts: true, cost: { energy: 1 },
        program: [{ op: "token", name: "Recruit", n: 1 }],
      }],
    },

    "Mushroom Pouch": {
      triggers: [{
        on: "beginningPhase", you: true, label: "facedown card: draw 1",
        condSpec: { k: "controlsHiddenBf" },
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Portal Rescue": {
      targets: [{ bind: "t", spec: { type: "unit", friendly: true }, prompt: "Banish and replay which friendly unit?" }],
      play: [
        { op: "banish", to: "$t" },
        { op: "playFrom", to: "$t", waive: "all", dest: "base" },
      ],
    },

    "Ava Achiever": {
      triggers: [{
        on: "attack", self: true, optional: true, label: "play a Hidden card here",
        program: [
          { op: "payCost", cost: { energy: 0, pips: 1, anyPower: 0, domains: ["mind"] }, skipOnFail: 2 },
          { op: "choose", bind: "_h", spec: { zone: "hand", hasKw: "hidden" }, prompt: "Play which Hidden card here?" },
          { op: "playFrom", to: "$_h", waive: "all" },
        ],
      }],
    },

    "Ekko, Recurrent": {
      deathRecycle: true,
      deathknell: [{ op: "readyRunes", n: 99 }],
    },

    "Heimerdinger, Inventor": {
      inheritExhaustAbilities: true,
    },

    "Kai'Sa, Evolutionary": {
      triggers: [{
        on: "unitConquer", self: true, optional: true, label: "play a cheap spell from your trash",
        program: [
          { op: "choose", bind: "_s", spec: { type: "spell", zone: "trash", maxEnergyVar: "points" }, prompt: "Play which spell from your trash?" },
          { op: "playFrom", to: "$_s", waive: "energy" },
        ],
      }],
    },

    "Swift Scout": {
      hideEnergyAlt: 1,
      legendAbilities: [{
        cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
        exhausts: true, label: "Swift Scout",
        targets: [{
          bind: "t",
          spec: { orSpecs: [
            { type: "unit", friendly: true, tag: "Teemo" },
            { type: "unit", zone: "champion", tag: "Teemo" },
          ] },
          prompt: "Put which Teemo into your hand?",
        }],
        program: [{ op: "toHand", to: "$t" }],
      }],
    },

    "Promising Future": {
      play: [{ op: "eachLookAndPlay", n: 5, waive: "energy", prompt: "Choose one to play, ignoring its Energy cost" }],
    },

    "Energy Conduit": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 1, pips: 0, anyPower: 0, domains: null },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Garbage Grabber": {
      abilities: [
        {
          cost: { energy: 1, pips: 0, anyPower: 0, domains: null },
          costRecycleTrash: 3,
          exhausts: true,
          label: "Garbage Grabber",
          targets: [],
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Seal of Insight": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            {
              op: "addResources",
              res: { energy: 0, pips: 1, anyPower: 0, domains: ["mind"] },
            },
          ],
          label: "Add",
        },
      ],
    },

    "Time Warp": { play: [{ op: "extraTurn" }, { op: "banishSelf" }] },

    "Consult the Past": { play: [{ op: "draw", n: 2 }] },

    "Falling Comet": {
      play: [{ op: "deal", to: "$t1", n: 6 }],
      targets: [
        { bind: "t1", spec: { type: "unit", atBf: true }, prompt: "Deal 6 to..." },
      ],
    },

    "Jeweled Colossus": {},

    "Lecturing Yordle": { play: [{ op: "draw", n: 1 }] },

    "Mega-Mech": {},

    "Progress Day": { play: [{ op: "draw", n: 4 }] },

    "Riptide Rex": {
      play: [{ op: "deal", to: "$t1", n: 6 }],
      targets: [
        {
          bind: "t1",
          spec: { type: "unit", enemy: true, atBf: true },
          prompt: "Deal 6 to...",
        },
      ],
    },

    "Watchful Sentry": { deathknell: [{ op: "draw", n: 1 }] },
  });
})();
